import React, { Component } from 'react';
import swal from 'sweetalert';
import { NavLink } from 'react-router-dom';
import request from 'superagent';
import util from '../helper/util';
import apis from '../helper/api';
import config from '../helper/config';
import PospayLogo from '../layout/metronic/pospay-logo-color.svg';

class ForgotPassword extends Component {
    constructor(props) {
        super(props)
        this.state = {
            username: "",
            flag_progressing: false
        }
        this.send = this.send.bind(this)
    }

    onChange(e) {
        this.setState({[e.target.name]: e.target.value})
    }

    send() {
        util.log(this.state)
        if (this.state.username.length === 0) {
            return swal("Ups!", "Masukkan nomor telepon atau kode agen Anda", "warning")
        }
        let self = this
        let whitelabel_36 = config.whitelabel.toString(36).toUpperCase()
        let body = {
            "white_label_id": whitelabel_36,
            "username": this.state.username
        }
        this.setState({flag_progressing: true})
        request.post(apis.forgot_password)
            .set("Content-Type", "application/json")
            .send(body)
            .end(function(err, res) {
                let message_result = ""
                if (err || !res.ok) {
                    util.log(err)
                    message_result = {title: "Error", body: err.message}
                    if (res !== undefined) {
                        message_result.body = "Error code " + res.statusCode
                    }
                } else {
                    util.log(res)
                    if (res.statusCode === 200) {
                        let payload = res.body
                        if (payload.status === "OK") {
                            message_result = {title: "Sukses", body: "Berhasil Forgot Password"}
                            if (payload.display_message !== undefined) {
                                message_result = {title: payload.error.message, body: payload.display_message}
                            }
                        } else {
                            message_result = {title: "Error", body: payload.error.message}
                            if (payload.display_message !== undefined) {
                                message_result = {title: payload.error.message, body: payload.display_message}
                            }
                        }
                    } else {
                        message_result = {title: "Error", body: res.statusCode}
                    }
                }
                if (message_result.length !== 0) {
                    swal(message_result.title, message_result.body, "warning")
                }
                self.setState({flag_progressing: false})
            })
    }

    render() {
        return (
            <div className="m-grid__item m-grid__item--fluid m-grid m-grid--hor m-login m-login--singin m-login--2 m-login-2--skin-2" id="m_login" style={{ backgroundImage: "url(swipe/assets/app/media/img/bg/bg-3-optimized.jpg)" }}>
                <div className="m-grid__item m-grid__item--fluid m-login__wrapper">
                    <div className="m-login__container">
                        <div className="m-login__logo" style={{margin: '0 auto 1.5rem auto',textAlign: 'center'}}>
                            <img style={{width:'auto', height:'120px', marginBottom:'10px'}} src={PospayLogo} />
                        </div>
                        <div className="m-login__signin">
                            <div className="m-login__head">
                                <h3 className="m-login__title">
                                    Lupa Password
                                </h3>
                            </div>
                            <form className="m-login__form m-form" action="">
                                <div className="form-group m-form__group">
                                    <input value={this.state.username} onChange={(e) => this.onChange(e)} className="form-control m-input" type="text" placeholder="Nomor Telepon / Kode Agen" name="username" autoComplete="off" />
                                </div>
                                <div className="m-login__form-action">
                                    <button style={{backgroundColor:'#003366',borderColor:'#003366'}} type="button" onClick={() => this.send()} id="m_login_signin_submit" 
                                        className={this.state.flag_progressing ? 'btn btn-focus m-btn m-btn--pill m-btn--custom m-btn--air m-login__btn m-loader m-loader--light m-loader--right' : 'btn btn-focus m-btn m-btn--pill m-btn--custom m-btn--air m-login__btn'}>
                                        Kirim
                                    </button>
                                </div>
                                <br/>
                                <div className="m-demo-icon">
                                    <div className="m-demo-icon__preview">
                                        <i className="la la-arrow-left"></i>
                                    </div>
                                    <div className="m-demo-icon__class">
                                        <NavLink id="m_login_forget_password" 
                                            className="m-link" 
                                            to="/login" style={{fontSize:16+'px'}}>
                                            Batal
                                        </NavLink>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>


            </div>
        )
    }
}
export default ForgotPassword
